import { useEffect, useState } from "react";
import { Download, Share, PlusSquare, MoreVertical } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { canPrompt, isIOS, isStandalone, onInstallChange, promptInstall } from "../lib/install";

const Step = ({ icon: Icon, children }) => (
  <li className="flex items-center gap-3 rounded-xl bg-slate-50 px-3 py-2.5 text-sm text-slate-700">
    <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-teal-700 text-white"><Icon size={16} /></span>{children}
  </li>
);

export const InstallButton = ({ t }) => {
  const [, force] = useState(0);
  const [help, setHelp] = useState(false);
  useEffect(() => onInstallChange(() => force((n) => n + 1)), []);
  if (isStandalone()) return null;

  const click = async () => { if (canPrompt()) await promptInstall(); else setHelp(true); };
  const ios = isIOS();
  return (
    <>
      <button data-testid="install-app-btn" onClick={click} aria-label={t("downloadApp")} title={t("downloadApp")}
        className="fade-up absolute bottom-7 right-3 z-10 flex h-9 items-center gap-1.5 rounded-full bg-white/90 py-1 pl-1 pr-3 text-xs font-semibold text-slate-700 shadow-md backdrop-blur transition-transform hover:scale-105 sm:bottom-8 sm:right-6">
        <span className="grid h-7 w-7 place-items-center rounded-full bg-teal-700 text-white"><Download size={14} /></span>{t("downloadApp")}
      </button>
      <Dialog open={help} onOpenChange={setHelp}>
        <DialogContent className="max-w-sm rounded-2xl" data-testid="install-help-dialog">
          <DialogHeader>
            <DialogTitle className="font-display">{t("installApp")}</DialogTitle>
            <DialogDescription>{t("installIntro")}</DialogDescription>
          </DialogHeader>
          <ol className="space-y-2">
            {ios ? (
              <>
                <Step icon={Share}>{t("installIos1")}</Step>
                <Step icon={PlusSquare}>{t("installIos2")}</Step>
              </>
            ) : (
              <>
                <Step icon={MoreVertical}>{t("installAndroid1")}</Step>
                <Step icon={Download}>{t("installAndroid2")}</Step>
              </>
            )}
          </ol>
        </DialogContent>
      </Dialog>
    </>
  );
};
